<template>
  <v-container fluid>
    <v-progress-circular v-if="this.saving"
        indeterminate
        color="green"
      ></v-progress-circular>
      <v-card>
        <v-card-title>
           Po dobavnim cijenama: {{ itemCrd.itemName }}, {{ itemCrd.itemID }}

          <v-spacer></v-spacer>
          <v-text-field
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            v-model="search"
          ></v-text-field>
        </v-card-title>

        <v-data-table
            dense
            :headers="headers"
            :items="grItems"
            item-key="id"
            :search="search"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50]
            }"
            :items-per-page="50"
            @click:row="otvoriKarticu"
            class="row-pointer"
          >
          <template v-slot:[`item.uDokument`]="{ item }">
            <v-btn x-small text color="primary" title="Dodaj u dokument"
              @click.stop="pushToDocument(item)">
              <v-icon x-small class="mr-1">mdi-plus</v-icon>u dokument
            </v-btn>
          </template>
          <template v-slot:[`item.documentDate`]="{ item }">
              <span>{{ localDate(item.documentDate) }}</span>
          </template>
          <template v-slot:[`item.itemPcsMinus`]="{ item }">
              <span>{{ localMoney(item.itemPcsMinus) }}</span>
          </template>
          <template v-slot:[`item.itemPcsPlus`]="{ item }">
              <span>{{ localMoney(item.itemPcsPlus) }}</span>
          </template>
          <template v-slot:[`item.itemState`]="{ item }">
              <span>{{ localMoney(item.itemState) }}</span>
          </template>
           <template v-slot:[`item.itemPriceWithVAT`]="{ item }">
              <span>{{ localMoney(item.itemPriceWithVAT) }}</span>
          </template>
          <template slot="pageText" slot-scope="{ pageStart, pageStop }">
            From {{ pageStart }} to {{ pageStop }}
          </template>
        </v-data-table>



          <v-card-text>
            {{lang.itemTotalPlus}} {{localMoney(totalPcsPlus)}},{{lang.itemTotalMinus}} {{localMoney(totalPcsMinus)}}, {{lang.itemTotal}} {{localMoney(totalPcs)}} <br />
            <span v-if="totalSupp"> {{lang.ItemSuppPriceAmount}}: {{localMoney(totalSupp)}},</span>
            <span v-if="totalMargin"> {{lang.ItemMarginAmount}}: {{localMoney(totalMargin)}},</span>
            <span v-if="totalNetto"> {{lang.ItemBaseAmountNoVAT}}: {{localMoney(totalNetto)}},</span>
            <span v-if="totalVAT"> {{lang.ItemVAT1Amount}}: {{localMoney(totalVAT)}},</span> 
            <span v-if="totalTotal"> {{lang.ItemFullTotal}}: {{localMoney(totalTotal)}}</span> 
          </v-card-text>
      </v-card>

    <WareHouseItemCard ref="kartica" />

  </v-container>
</template>

<script>
import DocumentService from '@/services/DocumentService'

import langEn from './documentDescEn'
import langHr from './documentDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import documentLocalName from '@/snippets/documentLocalName'
import documentCurrency from '@/snippets/documentCurrency'
import dateFormat from '@/snippets/dateFormat'
import moneyFormat from '@/snippets/moneyFormat'
import {defDocumentDetail, defNewDocumentDetail} from './documentHelper'
import { round, parseNum } from '@/snippets/allSnippets'
import dayjs from 'dayjs'
import WareHouseItemCard from './WareHouseItemCard'

export default {
  name: 'documentitemcardbysupp',
  props: [],
  data () {    
    return {
      selected: [],
      items: [],
      documentName: '',
      documentNameLoc: '',
      msg: '',
      tmp: '',
      search: '',
      pagination: {},
      rowsPerPageItems: [50],
      headers: [ ],
      columns: [],
      rows: [],
      lang: {},
      langC: {},
      saving: false,
      totalPcsPlus: 0,
      totalPcsMinus: 0,
      totalPcs: 0,
      totalSupp: 0,
      totalMargin: 0,
      totalNetto: 0,
      totalVAT: 0,
      totalDirect: 0, 
      totalTotal: 0,
      defCurr: 'EUR',
      itemState: 0,
      itemName: '',
      itemID: '',
      itemCrd:{},
      newDD:{},
      allItems:[],
      grItems:[]
    }
  },
  beforeMounted(){
    console.log('prije mounteda')
  },
  async mounted () {
      const query = {}
      if (this.$store.state.companyid) {
        query.CompanyId = this.$store.state.companyid
      }
      if (this.$store.state.businessYear) {
        query.BusinessYear = this.$store.state.businessYear
      }
      if (this.$store.state.itemActiv) {
        query.itemID = this.$store.state.itemActiv.itemID
      }
      query.docFromDate = dayjs([query.BusinessYear]).startOf('year').format('YYYY-MM-DD')
      query.docToDate = dayjs([query.BusinessYear]).endOf('year').format('YYYY-MM-DD')
      query.WareHouseId = this.$store.state.documentAna.WareHouseId ? this.$store.state.documentAna.WareHouseId  : 1

      this.saving = true
      const res = (await DocumentService.documentitemcard(query)).data
      this.newCardItems = res && res.document && res.document[0] ? res.document[0] : []
    
      this.itemCrd = this.$store.state.itemActiv ? this.$store.state.itemActiv : null

        // do analysis from database
        if (this.$store.state.language === 'EN') {
          this.lang = langEn
          this.langC = commEn
        }
        if (this.$store.state.language === 'HR') {
          this.lang = langHr
          this.langC = commHr
        }
        this.defCurr = documentCurrency()
        this.headers.push(
          {text: this.lang.ItemSuppPrice, value: 'category', type: 'decimal', width: '100px'},
          {text: this.lang.ItemPcsPlus, value: 'sumPlus', type: 'decimal', width: '100px'},
          {text: this.lang.ItemPcsMinus, value: 'sumMinus', type: 'decimal', width: '100px'},
          {text: this.lang.itemState, value: 'sumTotal', type: 'decimal', width: '100px'},
          {text: '', value: 'uDokument', sortable: false, width: '110px'}
        )

        
        // do analysis from database
        this.localError = false
        this.error = null
        this.items = []
 
        this.saving = false
        let iid = 0
        this.totalPcs = 0
        this.totalSupp = 0
        this.totalMargin = 0
        this.totalNetto = 0
        this.totalVAT = 0
        this.totalDirect = 0
        this.totalTotal = 0
        if (this.newCardItems) {
            this.newCardItems.map(item => {
              const newEntry = {}
              newEntry.itemPcsPlus = item.itemPcsPlus ? parseNum(item.itemPcsPlus) : 0
              newEntry.itemPcsMinus = item.itemPcsMinus ? parseNum(item.itemPcsMinus) : 0
              newEntry.itemSuppPrice = item.itemSuppPrice ? (item.itemSuppPrice) : 0
              newEntry.itemMargin = item.itemMargin ? item.itemMargin : ''
              newEntry.itemPrice = item.itemPrice ? item.itemPrice : ''
              newEntry.itemPriceWithVAT = item.itemPriceWithVAT ? item.itemPriceWithVAT : ''
              if (item.itemPcsPlus) {                
                this.totalPcsPlus += parseFloat(item.itemPcsPlus)
                newEntry.TotalPlus = this.totalPcsPlus
              } 
              if (item.itemPcsMinus) {                
                this.totalPcsMinus += parseFloat(item.itemPcsMinus)
                newEntry.TotalMinus = this.totalPcsMinus
              }
              newEntry.itemState = this.totalPcsPlus - this.totalPcsMinus    
              iid += 1
              newEntry.id = iid
              this.items.push(newEntry)
            })
            this.totalPcs = this.totalPcsPlus - this.totalPcsMinus
           }
        
        this.typeAna = 4
        this.doGroup()
  },
  methods: {
    doGroup() {
      this.grItems.length = 0
      const groupedData = this.items.reduce((acc, item) => {
        const key = item.itemSuppPrice;

        // Initialize the group if it doesn't exist
        if (!acc[key]) {
          acc[key] = { 
            category: key, 
            sumPlus: 0, 
            sumMinus: 0,
            sumTotal: 0,
          };
        }

        // Add the values
        acc[key].sumPlus += item.itemPcsPlus;
        acc[key].sumMinus += item.itemPcsMinus;
        acc[key].sumTotal += (item.itemPcsPlus - item.itemPcsMinus);

        return acc;
      }, {});

      this.grItems = Object.values(groupedData)
    },
    // Klik na redak otvara karticu artikla, istu koju otvara i stanje skladista.
    // Redci su ovdje razine dobavne cijene jednog te istog artikla, pa kartica
    // uvijek pokazuje taj artikl - ono sto ovaj pregled ne pokazuje su dokumenti,
    // datumi i partneri iza tih kolicina.
    otvoriKarticu () {
      const artikl = this.itemCrd
      if (!artikl || !artikl.itemID) { return }
      this.$refs.kartica.open({
        itemID: artikl.itemID,
        itemName: artikl.itemName,
        itemUnit: artikl.itemUnit,
        itemGroup: artikl.itemGroup,
        GroupName: artikl.GroupName,
        WareHouseId: this.$store.state.documentAna && this.$store.state.documentAna.WareHouseId
          ? this.$store.state.documentAna.WareHouseId
          : undefined,
        fromDate: dayjs([this.$store.state.businessYear]).startOf('year').format('YYYY-MM-DD'),
        toDate: dayjs([this.$store.state.businessYear]).endOf('year').format('YYYY-MM-DD')
      })
    },
    navigateTo () {
    },
     getRndInteger(min, max) {
      return Math.floor(Math.random() * (max - min) ) + min;
    },
    pushToDocument(item) {
      console.log('item', item)
      this.allItems.length = 0
      this.allItems = this.$store.state.documentActivItems ? [...this.$store.state.documentActivItems] : []
      // Spajanje, ne zamjena. Prije je druga linija bacala cijeli rezultat
      // defDocumentDetail() - a s njim i nule za itemSuppPriceAmount i
      // itemMarginAmount - jer this.documentDet u ovoj komponenti ne postoji,
      // pa je {...undefined} dalo prazan objekt. Ta dva polja onda nisu bila
      // ni definirana, a moneyFormat(undefined) ispisuje "NaN".
      this.newDD = {...defDocumentDetail(), ...defNewDocumentDetail()}
      const newId = this.getRndInteger(1000000000, 9000000000)
      this.newDD.id = newId
      let pcs = item && item.sumTotal ? parseNum(item.sumTotal,3) : 0
      const fromStore = this.$store.state.itemStore.find(itm => itm.itemID === this.itemCrd.itemID)

      this.newDD.itemID = fromStore.itemID
      this.newDD.itemName = fromStore.itemName
      this.newDD.ItemNameShort = fromStore.itemName
      this.newDD.itemGroup = fromStore && fromStore.GroupId ? fromStore.GroupId : ''
      this.newDD.itemGroupName = fromStore && fromStore.GroupName ? fromStore.GroupName : ''
      this.newDD.itemUnit = fromStore && fromStore.itemUnit ? fromStore.itemUnit : ''
      this.newDD.itemService = fromStore && fromStore.itemService ? fromStore.itemService : false
      this.newDD.ItemHomeCurrency = 'EUR'
      this.newDD.itemDiscountPercentage1 = 0
      this.newDD.itemVAT1Percentage = fromStore && fromStore.itemVAT1Percentage ? parseNum(fromStore.itemVAT1Percentage,2) : ''
      this.newDD.TypeName = fromStore && fromStore.TypeName ? fromStore.TypeName : '' 
      this.newDD.PotpunaSifra = fromStore && fromStore.PotpunaSifra ? fromStore.PotpunaSifra : '' 
      const suppPrice = parseNum(item.category,2)
      this.newDD.itemSuppBasePrice = parseNum(item.category,2)
      this.newDD.itemSuppDiscount = 0
      this.newDD.itemSuppPrice = parseNum(item.category,2)
      this.newDD.itemMargin = 0
      this.newDD.itemPrice = parseNum(item.category,2)
      this.newDD.itemPriceWithVAT = parseNum(item.category,2) * (1 + (parseNum(fromStore.itemVAT1Percentage,2) / 100))
      this.newDD.itemForePrice = parseNum(item.category,2)
      this.newDD.itemForePriceWithVAT = parseNum(item.category,2) * (1 + (parseNum(fromStore.itemVAT1Percentage,2) / 100))
      if (this.$store.state.documentSide === 1) {
        this.newDD.itemPcsPlus = pcs
      }
      if (this.$store.state.documentSide === 2) {
        this.newDD.itemPcsMinus = pcs
      }
      if (this.$store.state.documentSide === 3) {
        this.newDD.itemPcsNeutral = pcs
      }


      this.newDD.itemDirectDuty1 = 0
      this.newDD.itemSuppBasePriceAmount  = (suppPrice * pcs) ? round((suppPrice * pcs),2) : 0
      // bilo iSuppBasePriceAmount - ime iz DocumentDetailCreate2, ovdje ne postoji
      this.newDD.itemSuppPriceAmount  = this.newDD.itemSuppBasePriceAmount
      this.newDD.itemSuppDiscountAmount = 0
      this.newDD.itemBaseAmount = (suppPrice * pcs) ? (suppPrice * pcs): 0
      this.newDD.itemBaseAmount = round(this.newDD.itemBaseAmount, 2)
      // bilo this.iMarginAmount - postavljalo je polje na komponenti umjesto na
      // stavci, pa itemMarginAmount nikad nije bio postavljen
      this.newDD.itemMarginAmount = round((this.newDD.itemBaseAmount - this.newDD.itemSuppPriceAmount),2)

      this.newDD.itemDiscountAmount1 =  0
      this.newDD.itemDiscountAmount1 = round(this.newDD.itemDiscountAmount1, 2)
      this.newDD.itemBaseAmountNoVAT = this.newDD.itemBaseAmount  - this.newDD.itemDiscountAmount1
      this.newDD.itemBaseAmountNoVAT = round(this.newDD.itemBaseAmountNoVAT, 2)
      this.newDD.itemDiscountPrice = this.newDD.itemBaseAmountNoVAT && round(pcs,2) !== 0  ? round(this.newDD.itemBaseAmountNoVAT / pcs, 2)  : 0
      
      this.newDD.itemAmountWithVAT = this.newDD.itemBaseAmountNoVAT * (1 + (this.newDD.itemVAT1Percentage / 100)) ? this.newDD.itemBaseAmountNoVAT * (1 + (this.newDD.itemVAT1Percentage / 100)) : 0
      this.newDD.itemAmountWithVAT = round(this.newDD.itemAmountWithVAT, 2)
      this.newDD.itemVAT1Amount = this.newDD.itemAmountWithVAT - this.newDD.itemBaseAmountNoVAT
      this.newDD.itemPriceWithVAT = this.newDD.itemAmountWithVAT && round(pcs, 2) !== 0 ? round(this.newDD.itemAmountWithVAT / pcs, 2)  : 0
      this.newDD.itemDirectDuty1Amount = round((this.newDD.itemDirectDuty1 * pcs), 2)
      this.newDD.itemFullTotal = (this.newDD.itemAmountWithVAT + this.newDD.itemDirectDuty1Amount)
      this.newDD.itemFullTotal = round(this.newDD.itemFullTotal, 2)

      // if is PPO, then there is no VAT
      if (this.$store.state.documentActivHead.PPO === true) {
        this.newDD.itemAmountWithVAT = this.newDD.itemBaseAmountNoVAT
        this.newDD.itemAmountWithVAT = round(this.newDD.itemAmountWithVAT, 2)
        this.newDD.itemVAT1Percentage =  0
        this.newDD.itemVAT1Amount = 0
        this.newDD.itemPriceWithVAT = this.newDD.itemAmountWithVAT && round(pcs, 2) !== 0  ? round(this.newDD.itemAmountWithVAT / pcs, 2)  : 0
        this.newDD.itemDirectDuty1Amount = round((this.newDD.itemDirectDuty1 * pcs), 2)
        this.newDD.itemFullTotal = (this.newDD.itemAmountWithVAT + this.newDD.itemDirectDuty1Amount)
        this.newDD.itemFullTotal = this.newDD.round(this.newDD.itemFullTotal, 2)
        }
      // ako nije u sustavu PDVa
      if (this.$store.state.companyActiv.notinVAT === true) {
        this.newDD.itemAmountWithVAT = this.newDD.itemBaseAmountNoVAT
        this.newDD.itemAmountWithVAT = round(this.newDD.itemAmountWithVAT, 2)
        this.newDD.itemVAT1Percentage =  0
        this.newDD.itemVAT1Amount = 0
        this.newDD.itemPriceWithVAT = this.newDD.itemAmountWithVAT && round(pcs, 2) !== 0  ? round(this.newDD.itemAmountWithVAT / pcs, 2)  : 0
        this.newDD.itemDirectDuty1Amount = round((this.newDD.itemDirectDuty1 * pcs), 2)
        this.newDD.itemFullTotal = (this.newDD.itemAmountWithVAT + this.newDD.itemDirectDuty1Amount)
        this.newDD.itemFullTotal = this.newDD.round(this.newDD.itemFullTotal, 2)
      }
      this.setKategorije()

      this.allItems.push(this.newDD)
      const newTikTok = this.$store.state.tikTok + 1
      this.$store.dispatch('setTikTok', newTikTok)
    
      if (this.allItems) {
          this.$store.dispatch('setDocumentActivItems', this.allItems)
      } else {
        this.$store.dispatch('setDocumentActivItems', [])
      }
      this.makeSum()
      
    },
    makeSum() {
      const updateSumObject = {
        documentDescription9: 0,
        documentDescription10: 0,
        documentTotalVAT1Per: 0,
        documentTotalVAT1Base: 0,
        documentTotalVAT1Amount: 0,
        documentTotalVAT2Per: 0,
        documentTotalVAT2Base: 0,
        documentTotalVAT2Amount: 0,
        documentTotalVAT3Per: 0,
        documentTotalVAT3Base: 0,
        documentTotalVAT3Amount: 0,
        documentTotalVAT4Per: 0,
        documentTotalVAT4Base: 0,
        documentTotalVAT4Amount: 0,
        documentTotalVAT5Per: 0,
        documentTotalVAT5Base: 0,
        documentTotalVAT5Amount: 0,
        documentTotalAmountNetto: 0,
        documentTotalAmountVAT: 0,
        documentTotalAmountBrutto: 0,
        documentTotalAmountPayInAdvance: this.$store.state.documentActivHead.documentTotalAmountPayInAdvance ? parseFloat(this.$store.state.documentActivHead.documentTotalAmountPayInAdvance) : 0,
        documentTotalAmountToPay: 0,
        documentTotalAmountNettoForeign: 0,
        documentTotalAmountVATForeign: 0,
        documentTotalAmountBruttoForeign: 0,
        documentTotalAmountPayInAdvanceForeign: 0,
        documentTotalAmountToPayForeign: 0,
        documentTotalAmountDirectD1: 0,
        documentTotalAmountDirectD2: 0,
        documentTotalAmountDirectD1Fore: 0,
        documentTotalAmountDirectD2Fore: 0,
        supplierAmount: 0,
        supplierNetoAmount: 0,
        supplierDiscount: 0,
        supplierMargin: 0,
        FreeF1: 0,
        FreeF2: 0,
        FreeF3: 0,
        FreeF4: 0,
        FreeF5: 0,
        FreeF6: 0,
      }
      let dSide = 3
      if (this.$store.state.documentSide) {
        dSide = this.$store.state.documentSide
      }

      const hrVat1 = 25
      const hrVat2 = 13
      const hrVat3 = 5
  
      if (this.allItems) {
        this.allItems.map(documentDet => {

          this.pcsLoc = 0
          if (dSide === 1 ) {
            this.pcsLoc = parseFloat(documentDet.itemPcsPlus) ? parseFloat(documentDet.itemPcsPlus)  : 0
          }
          if (dSide === 2 ) {
            this.pcsLoc = parseFloat(documentDet.itemPcsMinus) ? parseFloat(documentDet.itemPcsMinus)  : 0
          }
          if (dSide === 3 ) {
            this.pcsLoc = parseFloat(documentDet.itemPcsNeutral) ? parseFloat(documentDet.itemPcsNeutral)  : 0
          }
          this.pcsLoc = this.round(this.pcsLoc, 3)     
          
          if ((documentDet.itemSuppBasePriceAmount)) {
            updateSumObject.supplierAmount += this.round((documentDet.itemSuppBasePriceAmount),2)
          }
          if (documentDet.itemSuppDiscountAmount) {
            updateSumObject.supplierDiscount += this.round(documentDet.itemSuppDiscountAmount,2)
          }
          if (documentDet.itemSuppPriceAmount) {
            updateSumObject.supplierNetoAmount += this.round(documentDet.itemSuppPriceAmount,2)
          }
          if (documentDet.itemBaseAmount) {
            updateSumObject.documentDescription9 += parseFloat(documentDet.itemBaseAmount)
          }
          if (documentDet.itemBaseAmountNoVAT) {
            updateSumObject.documentTotalAmountNetto += parseFloat(documentDet.itemBaseAmountNoVAT)
          }

          if (this.round(documentDet.itemVAT1Percentage, 2) === hrVat1) {
            updateSumObject.documentTotalVAT1Base += parseFloat(documentDet.itemBaseAmountNoVAT)
            // updateSumObject.documentTotalVAT1Amount += parseFloat(documentDet.itemVAT1Amount)
            // updateSumObject.documentTotalVAT1Base += parseFloat((documentDet.itemAmountWithVAT) - parseFloat(documentDet.itemVAT1Amount))
          }
          if (this.round(documentDet.itemVAT1Percentage, 2) === hrVat2) {
            updateSumObject.documentTotalVAT2Base += parseFloat(documentDet.itemBaseAmountNoVAT)
            // updateSumObject.documentTotalVAT2Amount += parseFloat(documentDet.itemVAT1Amount)
            // updateSumObject.documentTotalVAT2Base += parseFloat((documentDet.itemAmountWithVAT) - parseFloat(documentDet.itemVAT1Amount))
          }
          if (this.round(documentDet.itemVAT1Percentage, 2) === hrVat3) {
            updateSumObject.documentTotalVAT3Base += parseFloat(documentDet.itemBaseAmountNoVAT)
            // updateSumObject.documentTotalVAT3Amount += parseFloat(documentDet.itemVAT1Amount)
            // updateSumObject.documentTotalVAT3Base += (parseFloat(documentDet.itemAmountWithVAT) - parseFloat(documentDet.itemVAT1Amount))
          }
          if (documentDet.itemBaseAmount) {
            if (parseInt(documentDet.FreeF1) === 1) {
              updateSumObject.FreeF1 += parseFloat(documentDet.itemBaseAmount)
            }
            if (parseInt(documentDet.FreeF1) === 2) {
              updateSumObject.FreeF2 += parseFloat(documentDet.itemBaseAmount)
              updateSumObject.FreeF5 += parseFloat(documentDet.empWrkHrs)
            }
            if (parseInt(documentDet.FreeF1) === 3) {
              updateSumObject.FreeF3 += parseFloat(documentDet.itemBaseAmount)
            }
          }
          if (documentDet.itemBaseAmountNoVAT) {
            if (this.round(parseFloat(documentDet.itemVAT1Amount),2) === 0) {
              updateSumObject.FreeF4 += parseFloat(documentDet.itemBaseAmountNoVAT)
            }
          }
          if (documentDet.itemDirectDuty1Amount) {
            updateSumObject.documentTotalAmountDirectD1+= parseFloat(documentDet.itemDirectDuty1Amount)
          }
        })
      }

      updateSumObject.documentTotalAmountNetto = updateSumObject.documentTotalAmountNetto ? this.round(updateSumObject.documentTotalAmountNetto, 2) : 0
      updateSumObject.documentTotalVAT1Amount  = this.round((updateSumObject.documentTotalVAT1Base * ( (hrVat1/100))),2)
      updateSumObject.documentTotalVAT2Amount  = this.round((updateSumObject.documentTotalVAT2Base * ( (hrVat2/100))),2)
      updateSumObject.documentTotalVAT3Amount  = this.round((updateSumObject.documentTotalVAT3Base * ( (hrVat3/100))),2)
      updateSumObject.documentDescription9 = updateSumObject.documentDescription9 ? this.round(updateSumObject.documentDescription9, 2) : 0
      updateSumObject.supplierNetoAmount = updateSumObject.supplierNetoAmount ? this.round(updateSumObject.supplierNetoAmount, 2) : 0
      updateSumObject.supplierMargin = this.round(updateSumObject.documentTotalAmountNetto - updateSumObject.supplierNetoAmount, 2)
      updateSumObject.documentTotalAmountVAT = updateSumObject.documentTotalVAT1Amount + updateSumObject.documentTotalVAT2Amount + updateSumObject.documentTotalVAT3Amount
      updateSumObject.documentTotalAmountBrutto = updateSumObject.documentTotalAmountNetto + updateSumObject.documentTotalAmountVAT
      updateSumObject.documentTotalVAT1Per = hrVat1 ? this.round(hrVat1, 2) : 0
      updateSumObject.documentTotalVAT2Per = hrVat2 ? this.round(hrVat2, 2) : 0
      updateSumObject.documentTotalVAT3Per = hrVat3 ? this.round(hrVat3, 2) : 0

      // updateSumObject.documentTotalVAT1Base = hrVat1 && updateSumObject.documentTotalVAT1Amount ? this.round(updateSumObject.documentTotalVAT1Amount / (hrVat1/100), 2) : 0
      // updateSumObject.documentTotalVAT2Base = hrVat2 && updateSumObject.documentTotalVAT2Amount ? this.round(updateSumObject.documentTotalVAT2Amount / (hrVat2/100), 2) : 0
      // updateSumObject.documentTotalVAT3Base = hrVat3 && updateSumObject.documentTotalVAT3Amount ? this.round(updateSumObject.documentTotalVAT3Amount / (hrVat3/100), 2) : 0
      updateSumObject.FreeF1 = updateSumObject.FreeF1 ? this.round(updateSumObject.FreeF1, 2) : 0
      updateSumObject.FreeF2 = updateSumObject.FreeF2 ? this.round(updateSumObject.FreeF2, 2) : 0
      updateSumObject.FreeF3 = updateSumObject.FreeF3 ? this.round(updateSumObject.FreeF3, 2) : 0
      updateSumObject.FreeF4 = updateSumObject.FreeF4 ? this.round(updateSumObject.FreeF4, 2) : 0
      updateSumObject.FreeF5 = updateSumObject.FreeF5 ? this.round(updateSumObject.FreeF5, 2) : 0
      updateSumObject.documentDescription10 = updateSumObject.documentDescription9 - updateSumObject.documentTotalAmountNetto
      updateSumObject.documentTotalAmountPayInAdvance = updateSumObject.documentTotalAmountPayInAdvance ? this.round(updateSumObject.documentTotalAmountPayInAdvance, 2) : 0
      updateSumObject.documentTotalAmountToPay = updateSumObject.documentTotalAmountBrutto ? (this.round(updateSumObject.documentTotalAmountBrutto, 2) - (updateSumObject.documentTotalAmountPayInAdvance )): 0

      updateSumObject.documentTotalAmountNettoForeign = updateSumObject.documentTotalAmountNetto ? this.round((updateSumObject.documentTotalAmountNetto / this.ExRate), 2) : 0
      updateSumObject.documentTotalAmountVATForeign = updateSumObject.documentTotalAmountVAT ? this.round((updateSumObject.documentTotalAmountVAT / this.ExRate), 2) : 0
      updateSumObject.documentTotalAmountBruttoForeign = updateSumObject.documentTotalAmountBrutto ? this.round((updateSumObject.documentTotalAmountBrutto / this.ExRate), 2) : 0
      updateSumObject.documentTotalAmountPayInAdvanceForeign = this.round((updateSumObject.documentTotalAmountPayInAdvance  / this.ExRate), 2)
      updateSumObject.documentTotalAmountToPayForeign = updateSumObject.documentTotalAmountBrutto ? (this.round((updateSumObject.documentTotalAmountBrutto/ this.ExRate), 2) - (updateSumObject.documentTotalAmountPayInAdvance  / this.ExRate) ) : 0
      updateSumObject.documentTotalAmountDirectD1Fore = updateSumObject.documentTotalAmountDirectD1 ? this.round((updateSumObject.documentTotalAmountDirectD1 / this.ExRate), 2) : 0

      const newHead = {...this.$store.state.documentActivHead, ...updateSumObject}
      console.log('imam novi zbroj za glavu newHead ', newHead )
      if (newHead) {
        this.$store.dispatch('setDocumentActivHead', newHead)
      } else {
        this.$store.dispatch('setDocumentActivHead', {})
      }
    },
    setKategorije() {
      let uv = null
      if (this.newDD.itemVAT1Percentage === 25) {uv = 1}
      if (this.newDD.itemVAT1Percentage === 13) {uv = 2}
      if (this.newDD.itemVAT1Percentage === 5) {uv = 3}
      if (this.newDD.itemVAT1Percentage === 0) {uv = 4}
      // ako je dokument oznacen kao ino 
      if (this.$store.state.documentActivHead.exportDoc) {uv = 5 }
      // ako je dokument oznacen kao ppo
      if (this.$store.state.documentActivHead.PPO) {uv = 7 }
      if (this.$store.state.companyActiv.notinVAT === true) {uv = 13}
      const result = this.$store.state.OznakaKategorijePDV.filter(element => element.id === uv)
      if (result[0]) {
        const res = result[0]
        this.newDD.kod = res.value
        this.newDD.kodKategorije  = res.kodKategorije
        this.newDD.kodSheme = res.kodSheme
      }
    },
    round (value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
    },
    localMoney(moneyToFormat) {
      return moneyFormat(moneyToFormat)
    },
    localDate(dateToFormat) {
      return dateFormat(dateToFormat)
    },

  },
  computed: {

  },
  watch: {

  },
  components: {
    WareHouseItemCard
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>


